import React from "react";
import { Link } from "react-router-dom";

type Props = {};

export default function IndustriesPopover({}: Props) {
  return (
    <>
      <div className="radius-3 bg-teal-50 d-flex flex-column justify-content-start align-items-start overflow-hidden">
        <Link
          className="text-white-color font-family-roboto-flex fonts-400 font-14 line-16 py-2 w-100 ps-3"
          style={{ borderBottom: "1px solid #03AFB4" }}
          to={"/telecom"}
        >
          Telecom
        </Link>
        <Link
          className="text-white-color font-family-roboto-flex fonts-400 font-14 line-16 py-2 w-100 ps-3"
          style={{ borderBottom: "1px solid #03AFB4" }}
          to={"/retail"}
        >
          Retail Industry
        </Link>
        <Link
          className="text-white-color font-family-roboto-flex fonts-400 font-14 line-16 py-2 w-100 ps-3"
          style={{ borderBottom: "1px solid #03AFB4" }}
          to={"/healthcare"}
        >
          Health Care
        </Link>
        <Link
          className="text-white-color font-family-roboto-flex fonts-400 font-14 line-16 py-2 w-100 ps-3"
          to={"/energy-utilities"}
        >
          Energy and Utilities
        </Link>
      </div>
    </>
  );
}
